import React from "react";
import cheffIcon from "../assets/icons/cheff.png";
import eventIcon from "../assets/icons/event.png";
import freshIcon from "../assets/icons/fresh.png";
import hygienicIcon from "../assets/icons/Hygienic.png";

/* ─── Main Component ──────────────────────────────────────────── */
const WhyChooseUs = () => {
  const points = [
    {
      title: "Hygienic Food",
      description: "We are providing hygienic and fresh food.",
      icon: hygienicIcon,
    },
    {
      title: "Fresh Environment",
      description: "Our every outlet is in a good, welcoming environment.",
      icon: freshIcon,
    },
    {
      title: "Skilled Chefs",
      description: "Our skilled chefs satisfy your mouth cravings.",
      icon: cheffIcon,
    },
    {
      title: "Event & Party",
      description: "We are providing party halls for birthday celebrations and other events.",
      icon: eventIcon,
    },
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-[#faf6f0] overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

          {/* ── Left Side: Intro + Image ── */}
          <div className="lg:col-span-5 space-y-6">
            <div>
              <p className="font-sans text-[11px] font-bold tracking-[0.25em] text-[#9b1c2e] uppercase mb-3">
                Why Choose Us
              </p>
              <h2 className="text-[32px] sm:text-[40px] font-bold text-gray-900 leading-tight uppercase tracking-wide">
                Our Strength
              </h2>
              <div className="mt-4 w-12 h-0.5 bg-[#9b1c2e]" />
            </div>

            <p className="font-sans text-[14px] text-gray-600 leading-relaxed">
              At Barbequeen, we combine slow-smoked perfection, fresh local ingredients, and unparalleled hospitality to craft memorable dining moments for you and your loved ones.
            </p>

            <div className="relative h-[280px] sm:h-[340px] rounded-xl overflow-hidden shadow-lg group">
              <img
                src="https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=800&auto=format&fit=crop"
                alt="Grill and smoking meats"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </div>

          {/* ── Right Side: Grid Items ── */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {points.map((point, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-gray-100 flex items-center justify-center mb-6 group-hover:bg-[#9b1c2e] transition-colors duration-300">
                  <img
                    src={point.icon}
                    alt={point.title}
                    className="w-8 h-8 object-contain brightness-0 transition-all duration-300 group-hover:invert"
                  />
                </div>

                <h3 className="text-[16px] font-bold text-gray-900 uppercase tracking-wide mb-3">
                  {point.title}
                </h3>

                <p className="font-sans text-[13px] text-gray-600 leading-relaxed">
                  {point.description}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;

